import {VoltarAoTopoComponent} from './voltar-ao-topo.component';
import {CommonModule} from '@angular/common';
import {MatButtonModule, MatIconModule} from '@angular/material';
import {NgModule} from '@angular/core';


@NgModule({
  declarations: [
    VoltarAoTopoComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    VoltarAoTopoComponent
  ]
})
export class VoltarAoTopoModule { }
